module.exports = __webpack_public_path__ + "img/矩形 2627.6b9b52d2.png";